var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartContainer",class:_vm.className,style:({ height: _vm.localHeight, width: _vm.width }),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }